import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import { Typography, Tabs, Tab } from '@mui/material';
import { withStyles } from '@mui/styles';
import { StoreUtil } from 'doctivity-shared/utils';

import { UsageReportTab } from 'components/usage/UsageReportTab';
import { UsageCompareTab } from 'components/usage/UsageCompareTab';

const styles = (theme) => ({
  headerContainer: {
    marginBottom: theme.spacing(3),
  },
  header: {
    padding: theme.spacing(3),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.accent,
  },
  headerTitle: {
    color: '#FFFFFF',
    fontSize: 24,
    paddingRight: 30,
    flex: 1,
  },
  tabs: {
    paddingTop: 3,
    paddingLeft: theme.spacing(3),
    backgroundColor: theme.palette.primary.accent,
  },
  indicator: {
    backgroundColor: '#FFFFFF',
    height: 2,
    marginBottom: 8,
  },
  tabPanel: {
    color: '#E0E0E0',
    '&.Mui-selected': { color: '#FFFFFF' },
    '&:hover': { color: '#FFFFFF' },
  },
  subheader: {
    padding: `0 ${theme.spacing(3)}`,
    marginTop: theme.spacing(1),
  },
  prompt: {
    padding: theme.spacing(3),
  },
});

function UsageAnalyticsPageBase({ classes }) {
  const [tab, setTab] = useState('usage');

  const clientId = useSelector(({ app }) => app.selectedClient);
  const clientsList = useSelector(
    (state) => StoreUtil.getData(StoreUtil.get(state.clients, StoreUtil.COMMON_LIST)) || []
  );
  const clientName = (clientsList.find((c) => c.id === clientId) || {}).name;

  return (
    <>
      <title>Usage Analytics</title>
      <div className={classes.headerContainer}>
        <div className={classes.header}>
          <Typography className={classes.headerTitle}>Usage Analytics</Typography>
        </div>
        <Tabs
          variant='scrollable'
          className={classes.tabs}
          TabIndicatorProps={{ className: classes.indicator }}
          value={tab}
          onChange={(e, v) => setTab(v)}
        >
          <Tab className={classes.tabPanel} label='Client Usage' value='usage' disableRipple />
          <Tab className={classes.tabPanel} label='Client vs Client' value='compare' disableRipple />
        </Tabs>
      </div>

      {tab === 'usage' && (
        <div className={classes.subheader}>
          {clientId ? (
            <Typography variant='subtitle1'>
              Client:{' '}
              <span style={{ fontWeight: 700, color: '#000000' }}>
                {clientName || `#${clientId}`}
              </span>
            </Typography>
          ) : (
            <Typography variant='subtitle1' color='textSecondary'>
              Select a client from the top navigation to view its metrics.
            </Typography>
          )}
        </div>
      )}

      {tab === 'usage' && clientId && <UsageReportTab clientId={clientId} />}
      {tab === 'compare' && <UsageCompareTab />}
    </>
  );
}

UsageAnalyticsPageBase.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styled = withStyles(styles)(UsageAnalyticsPageBase);
export { styled as UsageAnalyticsPage };
